import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTrans } from "../../../hooks";
import { Loader } from "../../../shared-components";
import { BrowseStoryItemProps } from "../../story-item/BrowseStoryItem";

import StoryCarousel from "../components/StoryCarousel";
import SectionHeader from "../components/SectionHeader";

import { fetchPremiumPicks } from "../../catalog/reducers/premium-picks-catalog-reducer";

/**
 * Temporary Premium Picks home row containing a hero item as well as a carousel of current stories.
 */
const PremiumPicksSwimlane = ({
  sectionType,
  index,
  windowWidth,
  wasSeen,
  setPosition,
  page,
  onStoryClick,
  callTrackingUrls,
  currentPicks,
  isLoading,
  fetchPremiumPicks
}) => {
  const { trans } = useTrans();
  const el = useRef(null);

  const onSlideClicked = storyData => {
    if (wattpad.utils.getCurrentUserAttr("isPremium")) {
      onStoryClick(storyData);
    } else {
      app.router.navigate(`/catalog/premiumpicks`, { trigger: true });
    }
  };

  useEffect(
    () => {
      // Can't track position if the element is null
      if (!el.current) return;

      const boundingBox = el.current.getBoundingClientRect();
      setPosition(
        index,
        sectionType,
        boundingBox.top + window.scrollY,
        boundingBox.bottom + window.scrollY
      );
    },
    [index, sectionType, setPosition]
  );

  useEffect(
    () => {
      fetchPremiumPicks(true);
    },
    [fetchPremiumPicks]
  );

  return (
    <div className={classNames("premium-picks-swimlane module")} ref={el}>
      <div className="module-content">
        <SectionHeader
          heading={trans("Premium Picks")}
          sectionType={sectionType}
          subheading={trans(
            "Get a free monthly bundle of 5 Wattpad Originals with any Premium or Premium+ plan."
          )}
          expandPrompt={{
            weblink: "/catalog/premiumpicks",
            prompt: trans("View all"),
            isLink: true
          }}
        />
        {isLoading ? (
          <div className="loading-spinner">
            <Loader />
          </div>
        ) : null}
        {!isLoading ? (
          <StoryCarousel
            sectionType={sectionType}
            stories={currentPicks?.stories}
            windowWidth={windowWidth}
            index={index}
            wasSeen={wasSeen}
            storyWidth={300}
            page={page}
            onStoryClick={onSlideClicked}
            callTrackingUrls={callTrackingUrls}
          />
        ) : null}
      </div>
    </div>
  );
};

const readingListProps = {
  id: PropTypes.number,
  name: PropTypes.string,
  stories: PropTypes.arrayOf(PropTypes.shape(BrowseStoryItemProps)),
  total: PropTypes.number
};

PremiumPicksSwimlane.propTypes = {
  index: PropTypes.number.isRequired,
  sectionType: PropTypes.string.isRequired,
  setPosition: PropTypes.func.isRequired,
  wasSeen: PropTypes.bool,
  windowWidth: PropTypes.number,
  page: PropTypes.string,
  onStoryClick: PropTypes.func,
  callTrackingUrls: PropTypes.func,
  className: PropTypes.string,
  currentPicks: PropTypes.shape(readingListProps),
  isLoading: PropTypes.bool,
  loadError: PropTypes.string,
  fetchPremiumPicks: PropTypes.func
};

export default connect(
  state => ({
    currentPicks: state.premiumPicksCatalog.currentPicks,
    isLoading: state.premiumPicksCatalog.isLoading,
    loadError: state.premiumPicksCatalog.loadError
  }),
  { fetchPremiumPicks }
)(PremiumPicksSwimlane);
